/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_FilenameInputs */

const en_reports_filename = /** @type {(inputs: Reports_FilenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cases-by-client`)
};

const pt_br2_reports_filename = /** @type {(inputs: Reports_FilenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`casos-por-cliente`)
};

/**
* | output |
* | --- |
* | "cases-by-client" |
*
* @param {Reports_FilenameInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_filename = /** @type {((inputs?: Reports_FilenameInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_FilenameInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_filename(inputs)
	return pt_br2_reports_filename(inputs)
});